import script from "./seleksi.vue?vue&type=script&setup=true&lang=ts"
export * from "./seleksi.vue?vue&type=script&setup=true&lang=ts"

import "~/pages/_workflow.css?vue&type=style&index=0&id=a1ec52f4&scoped=true&lang=css&external"
import "./seleksi.vue?vue&type=style&index=1&id=a1ec52f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1ec52f4"]])

export default __exports__